export const getStyles = () => {
    const styles = {
        account: {
            alignItems: 'center',
            display: 'flex',
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: 'divider',
            height: 60,
            width: 60,
            borderRadius: '50%'
        },
        avatar: {
            height: 50,
            width: 50
        },
        menuItem: {
            borderRadius: 1,
            px: 1,
            py: 0.5
        },
        logout: {
            width: '100%',
            height: '40px',
            backgroundColor: '#F25A4F',
            color: '#FFFFFF',
            '&:hover': {
                backgroundColor: '#cc4339'
            }
        },
        popover: {
            width: "200px"
        }
    };
    return styles;
};